import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-jobs-page',
    templateUrl: './jobs-page.component.html',
    styleUrls: ['./jobs-page.component.scss']
})
export class JobsPageComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    jobSelected (n) {
        for (let i = 0; i < this.jobAccordion.length; i ++)
            this.jobAccordion[i].isOpen = (i == n)?!this.jobAccordion[i].isOpen:false;
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Shape the Future with Us!',
            subtitle: 'jobs',
            description: "Are you ready to be a pioneer in the world of Computer Vision AI? We're an early-stage startup with massive potential, driven by a passionate team dedicated to innovation and excellence. This is your opportunity to make a significant impact, grow with us, and be at the forefront of groundbreaking advancements in artificial intelligence. Come shape the future and revolutionize the industry with us!"
        }
    ]
    jobAccordion: Accordion[] = [
        {
            title: 'Full Stack Developer',
            location: "Locations: Gurgaon - India",
            overview: "An experienced Full Stack Developer with expertise in both frontend and backend development. The ideal candidate will have extensive experience with React, Next.js, TailwindCSS, and Vercel for frontend development, as well as FastAPI, WebSocket, and WebRTC with Python for backend development. This role requires a minimum of 5 years of professional experience and a strong understanding of modern web technologies, real-time communication, and secure API development on Ubuntu or MacOS.",
            responsibilities: [
                "Frontend Development: Develop and maintain scalable frontend applications using React, Next.js, and TailwindCSS.",
                "Backend Development: Build and maintain robust backend services using FastAPI and WebSocket.",
                "WebRTC Integration: Implement real-time communication features using WebRTC with Python, including STUN/TURN signaling.",
                "Deployment: Deploy and manage applications using Vercel and other relevant platforms.",
                "Performance Optimization: Optimize applications for maximum speed and scalability.",
                "Collaboration: Work closely with cross-functional teams to define, design, and ship new features.",
                "Security: Implement and maintain secure authentication and authorization protocols using Okta or Auth0.",
                "Data Handling: Work with file-based and server-based databases, ensuring efficient data management.",
                "Containerization: Utilize Docker for containerization and orchestration of applications.",
                "Media Streaming: Stream videos and data using WebRTC and WebSocket technologies.",
                "Documentation: Maintain comprehensive documentation of system architecture, APIs, and development processes."
            ],
            experience: [
                "Minimum of 5 years of professional experience in full stack development.",
                "Frontend Expertise: Extensive experience with React, Next.js, TailwindCSS, and Vercel.",
                "Backend Expertise: In-depth knowledge of FastAPI, WebSocket, and WebRTC with Python, including aiortc or similar libraries.",
                "Security: Proficiency in implementing authentication and authorization protocols using Okta or Auth0, and managing protected API routes.",
                "Data Management: Experience working with file-based and server-based databases.",
                "Containerization: Familiarity with Docker for containerization and orchestration.",
                "Media Handling: Experience with streaming videos and data using WebRTC and WebSocket, and implementing STUN/TURN protocols.",
                "Technical Skills: Strong understanding of HTML, CSS, JavaScript, and Python.",
                "Problem-solving: Excellent problem-solving skills and attention to detail.",
                "Communication: Strong communication and teamwork abilities."
            ],
            qualifications: [
                "Additional Skills: Familiarity with OpenCV and ffmpeg is a plus.",
                "Agile Development: Experience in Agile/Scrum development processes.",
                "Project Experience: Prior experience in media streaming applications.",
                "Scalability: Knowledge of backend server deployment, reverse proxy, and cloud scaling solutions.",
            ],
            isOpen: false
        },
        {
            title: 'Senior Frontend Developer',
            location: "Locations: San Francisco Bay Area, Gurgaon - India",
            overview: "An experienced Frontend Developer with expertise in React, Next.js, TailwindCSS, and Vercel technologies. The ideal candidate will have a deep understanding of WebRTC and WebSocket for media transfer over the internet, including STUN/TURN signaling.",
            responsibilities: [
                "Develop and maintain scalable frontend applications using React, Next.js, and TailwindCSS.",
                "Deploy and manage applications using Vercel.",
                "Implement real-time communication features using WebRTC and WebSocket.",
                "Optimize applications for maximum speed and scalability.",
                "Collaborate with cross-functional teams to define, design, and ship new features.",
                "Ensure the technical feasibility of UI/UX designs.",
                "Maintain code quality, organization, and automatization.",
                "Troubleshoot and debug complex issues related to WebRTC and WebSocket."
            ],
            experience: [
                "Minimum of 5 years of professional experience in frontend development.",
                "Extensive experience with React, Next.js, TailwindCSS, and Vercel.",
                "In-depth knowledge of WebRTC and WebSocket technologies, including STUN/TURN signaling.",
                "Strong understanding of HTML, CSS, and JavaScript.",
                "Experience with version control systems, preferably Git.",
                "Familiarity with modern frontend build pipelines and tools.",
                "Strong problem-solving skills and attention to detail.",
                "Excellent communication and teamwork abilities."
            ],
            qualifications: [
                "Experience with server-side rendering and static site generation.",
                "Knowledge of backend technologies and RESTful APIs.",
                "Familiarity with other JavaScript frameworks and libraries.",
                "Experience in Agile/Scrum development processes.",
                "Prior experience in media streaming applications."
            ],
            isOpen: false
        },
        {
            title: 'Senior Python Developer',
            location: "Locations: San Francisco Bay Area, Gurgaon - India",
            overview: "An experienced Python Developer with a strong background in building RESTful APIs using FastAPI and WebSocket, coupled with excellent knowledge of WebRTC with Python using aiortc or similar libraries. The ideal candidate will have over 7 years of professional experience, along with expertise in backend server deployment, reverse proxy, and authentication/authorization protocols using Okta or Auth0 frameworks.",
            responsibilities: [
                "Develop and maintain scalable RESTful APIs using FastAPI.",
                "Implement real-time communication features using WebSocket.",
                "Develop and maintain WebRTC functionalities using Python libraries such as aiortc.",
                "Manage backend server deployment and configure reverse proxies.",
                "Implement and maintain secure authentication and authorization protocols using Okta or Auth0.",
                "Ensure protected API routes and handle secure data transactions.",
                "Work with both file-based and server-based databases.",
                "Utilize Docker for containerization and orchestration of applications.",
                "Stream videos and data using WebRTC and WebSocket.",
                "Implement STUN/TURN protocols for peer-to-peer media streaming.",
                "Collaborate with cross-functional teams to define, design, and ship new features.",
                "Optimize applications for maximum speed and scalability.",
                "Troubleshoot and debug complex issues related to WebRTC and WebSocket."
            ],
            experience: [
                "Minimum of 7 years of professional experience in Python development.",
                "Extensive experience with FastAPI and WebSocket.",
                "In-depth knowledge of WebRTC with Python, including libraries such as aiortc.",
                "Strong understanding of backend server deployment and reverse proxy configuration.",
                "Expertise in authentication and authorization protocols using Okta or Auth0.",
                "Proficiency in managing protected API routes and secure data transactions.",
                "Experience working with file-based and server-based databases.",
                "Familiarity with Docker for containerization and orchestration.",
                "Strong problem-solving skills and attention to detail.",
                "Excellent communication and teamwork abilities."
            ],
            qualifications: [
                "Experience with video streaming and data transfer using WebRTC and WebSocket.",
                "Knowledge of STUN/TURN protocols for peer-to-peer media streaming.",
                "Familiarity with OpenCV and ffmpeg.",
                "Experience in Agile/Scrum development processes.",
                "Prior experience in media streaming applications."
            ],
            isOpen: false
        },
        {
            title: 'Systems Engineer',
            location: "Locations: San Francisco Bay Area, Gurgaon - India",
            overview: "An experienced Systems Engineer with a strong knowledge of computer hardware and scaling solutions in both cloud and on-premises environments. The ideal candidate will have extensive knowledge of network protocols, a deep understanding of read/write operations optimizations, in-memory caching, and handling large media files such as images and videos. A minimum of 5 years of experience in building on-premises servers, as well as deploying and maintaining web solutions, is required.",
            responsibilities: [
                "Design, build, and maintain on-premises server infrastructure.",
                "Scale computing loads in cloud and on-premises environments.",
                "Manage and optimize computer hardware, including CPU, memory, and GPU.",
                "Implement and maintain network protocols for efficient data transfer.",
                "Optimize read/write operations and in-memory caching for performance.",
                "Handle large media files, including images and videos, ensuring efficient storage and access.",
                "Deploy and maintain web solutions, ensuring high availability and performance.",
                "Monitor system performance, troubleshoot issues, and implement improvements.",
                "Collaborate with cross-functional teams to ensure system scalability and reliability.",
                "Document system configurations, procedures, and best practices.",
            ],
            experience: [
                "Minimum of 5 years of professional experience as a Systems Engineer.",
                "Strong knowledge of computer hardware, including CPU, memory, and GPU.",
                "Experience with scaling computing loads in cloud and on-premises environments.",
                "Extensive knowledge of network protocols and efficient data transfer techniques.",
                "Deep understanding of read/write operations and in-memory caching.",
                "Proficiency in handling large media files, including images and videos.",
                "Experience in building on-premises servers and deploying web solutions.",
                "Strong problem-solving skills and attention to detail.",
                "Excellent communication and teamwork abilities.",
            ],
            qualifications: [
                "Experience with cloud platforms such as AWS, Azure, or Google Cloud.",
                "Knowledge of storage solutions and file systems optimized for large media files.",
                "Familiarity with containerization technologies such as Docker.",
                "Experience with automation and configuration management tools.",
                "Knowledge of security best practices for system and network infrastructure.",
                "Prior experience in maintaining high-availability and high-performance systems.",
            ],
            isOpen: false
        },
        {
            title: 'Vice President of Engineering',
            location: "Locations: San Francisco Bay Area, Gurgaon - India",
            overview: "We are seeking a strategic and experienced Vice President of Engineering to oversee all engineering functions, including Frontend Development, Backend Development, and Systems Engineering. Reporting directly to the CEO, the VP of Engineering will lead a talented team of engineers, drive technological innovation, and ensure the successful delivery of our products and solutions.",
            responsibilities: [
                "Strategic Leadership: Provide strategic direction and leadership for the engineering team, aligning technology initiatives with business goals.",
                "Team Management: Manage and mentor a team of engineers across multiple disciplines, including Frontend Development, Backend Development, and Systems Engineering.",
                "Cross-functional Collaboration: Collaborate closely with Product Management, Sales, and Operations to define technical requirements and prioritize engineering efforts.",
                "Technical Oversight: Oversee the design, development, and deployment of scalable and reliable frontend and backend applications.",
                "Technology Stack Management: Manage and optimize technology stacks, including React, Next.js, FastAPI, WebSocket, WebRTC, and related technologies.",
                "Infrastructure Management: Oversee the design, deployment, and maintenance of on-premises and cloud-based infrastructure, ensuring scalability and reliability.",
                "Performance Optimization: Lead efforts to optimize system performance, including CPU, memory, GPU, network protocols, and data handling.",
                "Security and Compliance: Ensure engineering practices adhere to security best practices and regulatory requirements.",
                "Budget and Resource Management: Manage engineering budgets, resource allocation, and vendor relationships.",
                "Continuous Improvement: Drive continuous improvement initiatives, including process optimization, automation, and technical innovation.",
                "Reporting and Communication: Report directly to the CEO on engineering strategy, progress, and challenges.",
            ],
            experience: [
                "Leadership: Proven experience in a senior leadership role, ideally as VP of Engineering or similar, overseeing diverse engineering teams.",
                "Technical Expertise: Strong technical background with hands-on experience in frontend and backend development, systems engineering, and infrastructure management.",
                "Strategic Vision: Ability to formulate and drive technology strategy aligned with business objectives.",
                "Team Building: Demonstrated ability to build, mentor, and motivate high-performing engineering teams.",
                "Communication: Excellent communication skills with the ability to articulate technical concepts to non-technical stakeholders.",
                "Problem-solving: Strong analytical and problem-solving skills, with attention to detail and a commitment to quality.",
            ],
            qualifications: [
                "Industry Experience: Experience in a relevant industry such as tech startups, SaaS, or digital media.",
                "Education: Bachelor’s or Master’s degree in Computer Science, Engineering, or related field.",
                "Innovation: Track record of driving innovation and implementing emerging technologies.",
                "Strategic Partnerships: Experience in forming strategic partnerships and collaborations.",
            ],
            isOpen: false
        }
    ]

}
class pageTitle {
    title : string;
    subtitle : string;
    description: string;
}
class Accordion {
    title : string;
    location : string;
    overview: string;
    responsibilities: string[]
    experience: string[];
    qualifications: string[];
    isOpen: boolean
}